var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24892 14.1815C8.33647 14.6558 8.75003 15 9.2323 15H14.7677C15.25 15 15.6636 14.6558 15.7511 14.1815L16.0154 12.75H17.6916C18.5168 12.75 19.2298 12.1735 19.4027 11.3667L20.4742 6.36668C20.7076 5.27728 19.8771 4.25 18.763 4.25H17.5846L17.7819 3.18155C17.8954 2.56693 17.4235 2 16.7985 2H7.20153C6.57653 2 6.10468 2.56693 6.21815 3.18155L6.60002 5.25H10C10.4142 5.25 10.75 5.58579 10.75 6C10.75 6.41421 10.4142 6.75 10 6.75H6.87694L7.33848 9.25H10C10.4142 9.25 10.75 9.58579 10.75 10C10.75 10.4142 10.4142 10.75 10 10.75H7.6154L8.24892 14.1815ZM17.6916 11.25H16.2923L17.3077 5.75H18.763C18.9222 5.75 19.0408 5.89675 19.0075 6.05238L17.936 11.0524C17.9113 11.1677 17.8095 11.25 17.6916 11.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07703 16C8.66813 16 8.30042 16.249 8.14856 16.6286L6.3 21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H17.7L15.8514 16.6286C15.6996 16.249 15.3319 16 14.923 16H9.07703ZM12 20.5C11.1716 20.5 10.5 19.8284 10.5 19C10.5 18.1716 11.1716 17.5 12 17.5C12.8284 17.5 13.5 18.1716 13.5 19C13.5 19.8284 12.8284 20.5 12 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlender);
export default __webpack_public_path__ + "static/media/blender.97192c411dc2f2f94aa32ab93e43241e.svg";
export { ForwardRef as ReactComponent };